import type {Capability, FieldDefinition, ViewDefinition} from './view-definition'

/**
 * The fields the view definition declares as supporting `capability`, in declaration order.
 * A field must support the capability for *every* item kind the board carries — a field
 * attributable only on issues drops out when the board also carries pull requests.
 */
export function getFieldsForCapability(view: ViewDefinition, capability: Capability): FieldDefinition[] {
  if (view.itemKinds.length === 0) return []
  return view.fields.filter(field =>
    view.itemKinds.every(kind => field.capabilities[capability]?.includes(kind) ?? false),
  )
}
